import React from "react";
import { useLocation } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";

import { activityTracker } from "@/services/activityTracker";
import { resolveSaRouteActivityMeta } from "./saRouteActivityMeta";

const DEDUPE_MS = 30_000;

/**
 * Records Super Admin page views on route changes only (debounced per path).
 */
const SaPageViewTracker: React.FC = () => {
  const location = useLocation();
  const { user, isAuthenticated } = useAuth0();
  const lastTrackedRef = React.useRef<{ path: string; at: number } | null>(null);

  React.useEffect(() => {
    if (!isAuthenticated) return;

    const path = location.pathname;
    if (!path || path === "/") return;

    const meta = resolveSaRouteActivityMeta(path);
    if (!meta) return;

    const now = Date.now();
    const last = lastTrackedRef.current;
    if (last && last.path === path && now - last.at < DEDUPE_MS) {
      return;
    }
    lastTrackedRef.current = { path, at: now };

    void activityTracker.logSaPageView({
      routePath: path,
      pageTitle: meta.pageTitle,
      moduleName: meta.moduleName,
      userName: user?.name || user?.nickname || undefined,
      userEmail: user?.email || undefined,
    });
  }, [isAuthenticated, location.pathname, user?.email, user?.name, user?.nickname]);

  return null;
};

export default SaPageViewTracker;
